@if ({ note: note$ | async, item: watchlistItem$ | async }; as vm) {
  @if (type === 'default') {
    <div
      data-zid="watchlist-toggle-container"
      class="cursor-pointer ml-1"
      [ngbTooltip]="
        vm.note ? vm.note : vm.item ? ('watchlist-toggle.tooltip.rm' | transloco) : ('watchlist-toggle.tooltip.add' | transloco)
      "
      [openDelay]="500"
      [closeDelay]="200"
      (click)="toggleWatchlist(modalContent, $event, vm.item)"
    >
      <web-design-system-icon
        [attr.data-zid]="'watchlist-toggle-' + (vm.item ? 'active' : 'inactive')"
        [name]="!vm.item ? 'star' : 'star-1'"
        [size]="iconSize ?? 'small'"
      />
    </div>
  } @else {
    <web-design-system-icon-button
      [icon]="!vm.item ? 'star' : 'star-1'"
      type="grey-light"
      size="small"
      [ngbTooltip]="
        vm.note ? vm.note : vm.item ? ('watchlist-toggle.tooltip.rm' | transloco) : ('watchlist-toggle.tooltip.add' | transloco)
      "
      [openDelay]="500"
      [closeDelay]="200"
      (click)="toggleWatchlist(modalContent, $event, vm.item)"
    />
  }
}

<ng-template #modalContent let-modal>
  <web-design-system-modal
    [headline]="(isErrorModal ? 'watchlist-toggle.modal.header' : 'watchlist-toggle.modal.hint') | transloco"
    (dismiss)="modal.dismiss('Cross click')"
  >
    <form (ngSubmit)="modal.close('Submit')">
      <p>{{ modalmsg }}</p>
      @if (!isErrorModal) {
        <div class="d-flex justify-content-between align-items-md-center">
          <a class="cursor-pointer" (click)="modal.dismiss('dismiss')">
            {{ 'watchlist-toggle.modal.cancel' | transloco }}
          </a>
          <web-design-system-button [isSubmit]="true" size="small" (click)="modal.close('Button click')">
            {{ 'watchlist-toggle.modal.next' | transloco }}
          </web-design-system-button>
        </div>
      }
      @if (isErrorModal) {
        <web-design-system-button size="small" [fullwidth]="true" (click)="modal.dismiss('OK')">
          {{ 'watchlist-toggle.modal.confirm' | transloco }}
        </web-design-system-button>
      }
    </form>
  </web-design-system-modal>
</ng-template>
